import React, { FunctionComponent } from 'react'

import thumbsDownUrl from '../../assets/thumbs-down-rating.png'
import { Image } from '../image/Image'

interface ThumbsDownIllustrationProps {
  size?: number
}

export const ThumbsDownIllustration: FunctionComponent<ThumbsDownIllustrationProps> = ({ size = 48 }) => {
  return <Image source={thumbsDownUrl} accessibilityIgnoresInvertColors style={{ height: size, width: size }} />
}
